import { InputHTMLAttributes, useEffect, useRef, useState } from "react";
import i18n from "locales/i18n";
import { langProps } from "interface/index";
import { initialSelectData } from "components/utils/comm";
import "./select.scss";

type IDataTyp = "C" | "R" | "U";

export interface SelectProps extends InputHTMLAttributes<HTMLInputElement> {
  options: any[];
  defaultValue?: any;
  dataTyp?: IDataTyp;
  isUpdateAble?: boolean;
  styles?: string;
  ulStyles?: string;
  validateTxt?: string;
  isInitialData?: boolean;
  isReset?: boolean;
  onSelect?: (option: any) => void;
}
export default function Select({
  options,
  defaultValue,
  dataTyp = "C",
  isUpdateAble = false,
  styles = "bg-white border-1",
  ulStyles = "top-[26px] bg-white",
  isInitialData = true,
  validateTxt = "선택사항을 선택하여 주세요.",
  isReset = false,
  onSelect,
  ...res
}: SelectProps) {
  const langCd = i18n.language;

  const inputRef = useRef<HTMLInputElement>(null);
  const selectRef = useRef<HTMLDivElement>(null);

  const [isOpen, setIsOpen] = useState(false);
  const [prevValue, setPrevValue] = useState("");
  const [option, setOption] = useState<any>(initialSelectData); // 선택된 option

  const fullOptions = isInitialData ? [initialSelectData, ...options] : options;

  const outSideClick = (e: any) => {
    if (selectRef.current && !selectRef.current.contains(e.target)) {
      setIsOpen(false);
      selectRef.current.style.setProperty("--icon-rotate", "180deg");
      setPrevValue("");
    }
  };

  useEffect(() => {
    if (!defaultValue) return;
    if (defaultValue[langCd]) {
      setOption(defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    if (isReset) {
      setOption(defaultValue || initialSelectData);
    }
  }, [isReset]);

  useEffect(() => {
    document.addEventListener("click", outSideClick);

    return () => {
      document.removeEventListener("click", outSideClick);
    };
  }, []);

  return (
    <>
      <div
        ref={selectRef}
        data-type={dataTyp}
        className={`select-wrap ${styles}`}
        onClick={(e) => {
          setIsOpen(!isOpen);
          setPrevValue("all");
          if (inputRef.current) {
            inputRef.current.setCustomValidity("");
          }

          e.currentTarget.style.setProperty(
            "--icon-rotate",
            isOpen ? "180deg" : "0deg"
          );
        }}
      >
        {/* 선택된 item */}
        <span className="absolute cursor-pointer">
          {option ? option[langCd as keyof langProps] : ""}
        </span>
        <input
          ref={inputRef}
          type="text"
          className="opacity-0"
          value={option?.code || prevValue}
          data-type={dataTyp}
          autoComplete="off"
          autoCapitalize="off"
          data-updateable={isUpdateAble.toString()}
          onInvalid={(e) => e.currentTarget.setCustomValidity(validateTxt)}
          onInput={(e) => e.currentTarget.setCustomValidity("")}
          required={res.required}
          {...res}
        />

        {/* 리스트 영역 */}
        {isOpen && (
          // 리스트 없을때 : 검색된 결과가 없습니다.
          <ul className={ulStyles}>
            {options.length === 0 && (
              <li>
                <h4>검색된 결과가 없습니다.</h4>
              </li>
            )}
            {options.length !== 0 &&
              fullOptions.map((list) => {
                return (
                  <li
                    key={list.value}
                    onClick={(e) => {
                      onSelect && onSelect(list);
                      //전체를 선택하였을때 prevValue reset
                      if (!list.code) {
                        option?.code ? setOption(list) : setPrevValue("");
                      }
                      if (list.code) {
                        setOption(list);
                        setPrevValue("");

                        // 🔥 에러 상태 반드시 제거
                        if (inputRef.current) {
                          inputRef.current.setCustomValidity("");
                        }
                      }

                      // updateAble true일때
                      if (inputRef.current) {
                        const { updateable } = inputRef.current?.dataset;
                        if (updateable === "true") {
                          inputRef.current.setAttribute("data-type", "U");
                        }
                      }
                    }}
                  >
                    {list[langCd as keyof langProps]}
                  </li>
                );
              })}
          </ul>
        )}
      </div>
    </>
  );
}
